/**
 * Enum to specify the target for opening a deal.
 * Used with the `openDeal` callback to control where the deal opens.
 */
export enum OpenInTarget {
    /** Opens the deal in the same tab/window */
    SELF = '_self',
    /** Opens the deal in a new tab/window */
    BLANK = '_blank'
}

export enum RecentDealsVariant {
    OVERLAY = 'overlay',
    DOCKED = 'docked'
}
